// extracted by mini-css-extract-plugin
module.exports = {"form":"LU0lGWfHdF3YuLnV0bV5GA==","formColumn":"_0OIiJh92Y1G8GHCDJvN6nw=="};